module.exports = __webpack_public_path__ + "img/300325168.7271040e.png";